import React, {useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import {connect} from 'react-redux'
import {useTranslation} from 'react-i18next';
import {fetchShippings, sendShipping, setSelectedShippings} from "../../../../store/actions/store/ShippingAction";
import Button from "../../inputs/Button";
import TextField from "@mui/material/TextField";

const SendShippingDialog = ({open, setOpen, sending, selected, refresh, sendShipping, refreshing, resetSelected}) => {
    const {t} = useTranslation();
    const [tracking, setTracking] = useState();

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {
        e.stopPropagation();
        e.preventDefault();

        sendShipping(Object.keys(selected), tracking)
            .then(refresh)
            .then(resetSelected)
            .then(handleClose);
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('shipping_send_title')}
            aria-describedby={t('shipping_send_title')}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle
                    id="shipping-send-title">{t('shipping_send_title', {count: Object.keys(selected).length})}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="shipping-send-description">
                        {t('shipping_send_description')}
                    </DialogContentText>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField label={t('shipping_tracking')} fullWidth variant="outlined" value={tracking}
                                       disabled={refreshing || sending}
                                       onChange={e => setTracking(e.target.value)}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={refreshing || sending}>
                        {t('close_btn')}
                    </Button>
                    <Button color="primary" variant='contained' loading={refreshing || sending}
                            disabled={refreshing || sending} type='submit'>
                        {t('send_btn')}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        refreshing: state.shipping.shippingsLoading,
        sending: state.shipping.sendingShipping,
        selected: state.shipping.selectedShippings
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        refresh: () => dispatch(fetchShippings()),
        sendShipping: (ids, tracking) => dispatch(sendShipping(ids, tracking)),
        resetSelected: () => dispatch(setSelectedShippings({}))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendShippingDialog);